const SEO_WINES_PATH = `/vinos`
const SEO_WINES_TITLE = `nuestro catálogo de vinos`
const SEO_WINES_DESCRIPTION =
  'Puedes comprar cualquiera de nuestros vinos quantvm. Somos de Toledo vendemos y distribuimos vino por toda Castilla-La Mancha, Madrid y toda la península'

const seo = {
  path: SEO_WINES_PATH,
  title: SEO_WINES_TITLE,
  description: SEO_WINES_DESCRIPTION,
}

export default seo
